import React from "react";
import "./PioneeringMemberCouncil.css"; // We'll write custom styles
import PioneeringMember1 from "../assets/img/PioneeringMember1.png";
import PioneeringMember2 from "../assets/img/PioneeringMember2.png";
import PioneeringMember3 from "../assets/img/PioneeringMember3.png";
import PioneeringMember4 from "../assets/img/PioneeringMember4.png";
import PioneeringMember5 from "../assets/img/PioneeringMember5.png";
import PioneeringMember6 from "../assets/img/PioneeringMember6.png";
import PioneeringMember7 from "../assets/img/PioneeringMember7.png";
import PioneeringMember8 from "../assets/img/PioneeringMember8.png";
import PioneeringMember9 from "../assets/img/PioneeringMember9.png";
import PioneeringMember10 from "../assets/img/PioneeringMember10.png";
import PioneeringMember11 from "../assets/img/PioneeringMember11.png";

const PioneeringMemberCouncil = () => {
  const logos = [
    PioneeringMember1,
    PioneeringMember2,
    PioneeringMember3,
    PioneeringMember4, // replace with imports
    PioneeringMember5,
    PioneeringMember6,
    PioneeringMember11,
    PioneeringMember7,
    PioneeringMember8,
    PioneeringMember9,
    PioneeringMember10,
  ];

  return (
    <div className="pioneering-wrapper">
      {/* Header */}
      <section className="pioneering-header" data-aos="fade-up">
        <h2>Pioneering Member of the Council</h2>
        <div className="separator"></div>
      </section>

      {/* Logo Grid */}
      <div className="logo-grid">
        {logos.map((logo, index) => (
          <div className="logo-card" key={index}>
            <img src={logo} alt={`Logo ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PioneeringMemberCouncil;
